import intl from "react-intl-universal";
import styles from "./index.module.scss";
import { useNavigate } from "react-router-dom";
import Tooltip from '@/components/Tooltip/index';
const OurSource = () => {
  const navigate = useNavigate();
  const list = [
    {
      title: "Open Geospatial Data",
      label: "Open Data",
      link: "/open-datasets?type=OpenGeospatialData&title=OpenData",
      desc: "Resources.1",
    },
    {
      title: "Open AI Training Data",
      label: "Open Data",
      link: "/open-datasets?type=OpenAITrainingData&title=OpenData",
      desc: "Resources.2",
    },
    {
      title: "Open Data Services",
      label: "Open Data",
      link: "/open-datasets?type=OpenDataServices&title=OpenData",
      desc: "Resources.3",
    },
    {
      title: "Open Codes",
      label: "Open Tools",
      link: "/open-datasets?type=OpenCodes&title=OpenTools",
      desc: "Resources.4",
    },
    {
      title: "Open Executables",
      label: "Open Tools",
      link: "/open-datasets?type=OpenExecutables&title=OpenTools",
      desc: "Resources.5",
    },
    {
      title: "Open SDKs",
      label: "Open Tools",
      link: "/open-datasets?type=OpenSDKs&title=OpenTools",
      desc: "Resources.6",
    },
    {
      title: "Open Container Images",
      label: "Open Tools",
      link: "/open-datasets?type=OpenContainerImages&title=OpenTools",
      desc: "Resources.7",
    },
    {
      title: "Open Process Services",
      label: "Open Tools",
      link: "/open-datasets?type=OpenProcessServices&title=OpenTools",
      desc: "Resources.8",
    },
    {
      title: "Specifications Docs",
      label: "Open Docs",
      link: "/open-datasets?type=OpenSpecifications&title=OpenDocs",
      desc: "Resources.9",
    },
    {
      title: "Technical Docs",
      label: "Open Docs",
      link: "/open-datasets?type=TechnicalDocs&title=OpenDocs",
      desc: "Resources.10",
    },
    {
      title: "Development Guidelines",
      label: "Open Docs",
      link: "/open-datasets?type=DevelopmentGuidelines&title=OpenDocs",
      desc: "Resources.11",
    },
    {
      title: "Training & Course Materials",
      label: "Open Docs",
      link: "/open-datasets?type=TrainingCourseMaterials&title=OpenDocs",
      desc: "Resources.12",
    },
    {
      title: "Open Web Apps",
      label: "Open Apps",
      link: "/open-datasets?type=OpenWebApps&title=OpenApps",
      desc: "Resources.13",
    },
  ];

  const handleLinkTo = (e) => {
    navigate("/discover" + e.link);
  };
  return (
    <div className="container">
      <h1 style={{ textAlign: "center" }}>
        {intl.get("Home.Explore our resources")}
      </h1>
      <div className={styles.item_wrap}>
        {list.map((item, index) => {
          return (
            <div
              key={index}
              className="wow animate__fadeInUp"
              data-wow-duration={`${index * 0.2}s`}
              onClick={() => handleLinkTo(item)}
            >
              <div className="flex_box align_center">
                <span className={styles.item_title}>
                  <Tooltip lineClamp={1} placement="right" text={intl.get(`Header.${item.title}`)} title={intl.get(`Header.${item.title}`)}>
                  </Tooltip>
                </span>
                <span className={styles.item_label}>
                  {intl.get(`Header.${item.label}`)}
                </span>
              </div>
              <div className={styles.desc}>
                <Tooltip lineClamp={4} text={intl.get(item.desc)} placement="right" title={intl.get(item.desc)}>
                </Tooltip>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default OurSource;
